import React, { useState } from "react";
import {Alert} from "../../../controls";

const agentCodeIsValid = (code) => {
  if (code) {
    const serialString = code.toString();
    if (serialString.length < 8)
      return false;
    const lastDigit = serialString[7];
    const checkValue = parseInt(serialString.substr(0,7));
    const checkDigit = checkValue % 7;
    if (parseInt(lastDigit) === checkDigit)
      return true;
  }
  return false;
}


const NewCompanyValidator = (props) => {
  const record = props.data ?  props.data.record : props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }

  if (!error && !record.companyName) {
    error = true;
    errorMessage = "'Company Name' is required";
  }
  if (!error && record.iataAgentCode && (isNaN(record.iataAgentCode) || record.iataAgentCode > 99999999)) {
    error = true;
    errorMessage = "'IATA Agent Code' not valid. IATA agent codes are 8 numeric digits.";
  }
  if (!error && record.iataAgentCode && (!isNaN(record.iataAgentCode) && !agentCodeIsValid(record.iataAgentCode))) {
    error = true;
    errorMessage = "'IATA Agent Code' not valid. Invalid check digit";
  }
  if (!error && record.cassAddress && (!isNaN(record.cassAddress) || record.cassAddress > 9999)) {
    error = true;
    errorMessage = "'CASS Address' not valid. CASS address codes are 4 numeric digits.";
  }
  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage});
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default NewCompanyValidator;
